module.exports = function() {
  return new Worker(__webpack_public_path__ + "be405f09ec1dda8ec1b4.worker.js");
};